import React from 'react'
import { NavLinks } from '@frontend/components/agromarket/components/MainHeader'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { Image, Logo } from '@/components/ui'
import { messages } from './messages'
import './styles.scss'

const Error404Page = () => {
  return (
    <>
      <section className="page-404">
        <Logo url="/" color={EColor.BLACK} className="page-404__logo" />

        <h2 className="page-404__title">{messages.title}</h2>

        <NavLinks />
      </section>

      <div className="page-404-image-wrapper">
        <Image isInStatic src="errors/404.png" />
      </div>
    </>
  )
}

export default Error404Page
